import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldContentBlockerTemplateShouldForceToShowVisual() {
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    const options = useMemo(()=>[
            {
                label: t("Yes"),
                value: true
            },
            {
                label: t("No"),
                value: false
            }
        ], []);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.ShouldForceToShowVisual,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isVisual !== next.isVisual || prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>getFieldValue("isVisual") === true && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.ShouldForceToShowVisual, t),
                    extra: t("In rare cases, visual content blockers are not displayed because the main element of the blocked content is not visible either. Enable this option if this is the case and you want to force to display a content blocker for non-visible elements."),
                    shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                    required: true,
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        const extendedShouldForceToShowVisual = extended?.[ContentBlockerField.ShouldForceToShowVisual];
                        return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ContentBlockerField.ShouldForceToShowVisual,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    value: extendedShouldForceToShowVisual,
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid",
                                    disabled: true
                                })
                            }),
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                name: ContentBlockerField.ShouldForceToShowVisual,
                                noStyle: true,
                                rules: [
                                    {
                                        required: hasCreatorRole,
                                        message: t("Please choose a default setting.")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid"
                                })
                            })
                        });
                    }
                })
        })
    });
}
export { FormFieldContentBlockerTemplateShouldForceToShowVisual };
